export class ReceiptDataModel {
  public firstName: string;
  public lastName: string;
  public street: string;
  public streetNumber: string;
  public postalCode: string;
  public city: string;
  public country: string = 'de';
  public worth: number;
  public worthDate: string;
}


// WEBPACK FOOTER //
// ./src/app/checkout/models/receiptData.model.ts